/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "arrow-simple-right-bb7628dd--sprite",
  "use": "arrow-simple-right-bb7628dd--sprite-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 36 36\" id=\"arrow-simple-right-bb7628dd--sprite\">\r\n  <defs>\r\n    <clipPath id=\"arrow-simple-right-bb7628dd--sprite_clip-Arrow_Next_Slider\">\r\n      <rect width=\"36\" height=\"36\" />\r\n    </clipPath>\r\n  </defs>\r\n  <g id=\"arrow-simple-right-bb7628dd--sprite_Arrow_Next_Slider\" clip-path=\"url(#arrow-simple-right-bb7628dd--sprite_clip-Arrow_Next_Slider)\">\r\n    <g id=\"arrow-simple-right-bb7628dd--sprite_Rectangle_9264\" data-name=\"Rectangle 9264\" transform=\"translate(36 36) rotate(180)\" fill=\"#fff\" stroke=\"#707070\" stroke-width=\"1\" opacity=\"0\">\r\n      <rect width=\"36\" height=\"36\" stroke=\"none\" />\r\n      <rect x=\"0.5\" y=\"0.5\" width=\"35\" height=\"35\" fill=\"none\" />\r\n    </g>\r\n    <g id=\"arrow-simple-right-bb7628dd--sprite_Group_18706\" data-name=\"Group 18706\" transform=\"translate(16 23) rotate(-90)\">\r\n      <path id=\"arrow-simple-right-bb7628dd--sprite_Path_7013\" data-name=\"Path 7013\" d=\"M261.562,198.984l5,5,5-5\" transform=\"translate(-261.562 -198.983)\" fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" />\r\n    </g>\r\n  </g>\r\n</symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
